<template>
  <MobileCol>
    <v-card v-if="collegeExam">
      <v-card-title primary-title>
        Vraag {{ currentQuestionOrder + 1 }} van {{ collegeDocumentQuestions.length }}
      </v-card-title>
      <v-card-text>
        {{ currentQuestionContent }}
      </v-card-text>
      <v-card-actions
          v-for="collegeDocumentAnswer in collegeDocumentAnswers"
          :key="collegeDocumentAnswer.id">
        <v-btn
          block color="primary" dark
          @click="answer(collegeDocumentAnswer.id)"
        >
          {{ collegeDocumentAnswer.content }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </MobileCol>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import MobileCol from '../components/MobileCol.vue';

export default {
  name: 'CollegeExam',
  components: {
    MobileCol,
  },
  data() {
    return {
      collegeExam: undefined,
      collegeExamId: this.$route.query.collegeExamId,
    };
  },
  computed: {
    ...mapState('collegeDocumentQuestions', ['collegeDocumentQuestions']),
    ...mapState('collegeDocumentAnswers', ['collegeDocumentAnswers']),
    currentQuestionOrder() {
      return this.collegeExam?.currentQuestionOrder ?? 0;
    },
    currentQuestion() {
      const index = this.currentQuestionOrder;
      return this.collegeDocumentQuestions[index];
    },
    currentQuestionContent() {
      return this.currentQuestion?.content;
    },
    lastQuestionOrder() {
      const orders = this.collegeDocumentQuestions.map((c) => c.ordering);
      return Math.max(...orders);
    },
  },
  watch: {
    currentQuestion: {
      immediate: true,
      deep: true,
      handler() {
        if (this.currentQuestion) {
          this.LOAD_collegeDocumentAnswers(this.currentQuestion.id);
        } else {
          this.$log.debug('skipping loading college documents as the questions are not available yet');
        }
      },
    },
  },
  async mounted() {
    await this.refresh();
  },
  methods: {
    ...mapActions('collegeDocumentQuestions', ['LOAD_collegeDocumentQuestions']),
    ...mapActions('collegeExams', ['LOAD_collegeExam']),
    ...mapActions('collegeExamAnswers', ['CREATE_collegeExamAnswer']),
    ...mapActions('collegeDocumentAnswers', ['LOAD_collegeDocumentAnswers']),
    async answer(collegeDocumentAnswerId) {
      this.isLoading = true;
      const { collegeExamId } = this;
      await this.CREATE_collegeExamAnswer({ collegeDocumentAnswerId, collegeExamId });
      if (this.currentQuestion.ordering === this.lastQuestionOrder) {
        this.$log.info('exam completed');
        this.$router.push({
          name: 'membership-CollegeExamCompleted',
          query: { collegeExamId },
        });
      } else {
        this.$log.info('loading next question');
        await this.refresh();
      }
      this.isLoading = false;
    },
    async refresh() {
      this.isLoading = true;
      this.collegeExam = await this.LOAD_collegeExam(this.collegeExamId);
      await this.LOAD_collegeDocumentQuestions(this.collegeExam.collegeDocumentId);
      this.isLoading = false;
    },
  },
};
</script>
